import { render, staticRenderFns } from "./addprospect.vue?vue&type=template&id=dd222d66"
import script from "./addprospect.vue?vue&type=script&lang=js"
export * from "./addprospect.vue?vue&type=script&lang=js"
import style0 from "./addprospect.vue?vue&type=style&index=0&id=dd222d66&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports